import styles from "./../../styles/charts/chartStyle.module.css";
import { useState } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Paper,
  Modal,
  Box,
  Typography,
} from "@mui/material";
import { usePropertyData } from "../../lib/hooks";
import BarChart from "./protoCharts/BarChart";
import {
  getChartBottomIcons,
  getChartInfoIcons,
} from "./twitter/TwitterWordCloud";
import { desc } from "../../lib/chartDescription";

interface VariationOfFundsProps {
  xlabel: string;
  ylabel: string;
  type?: "Proposal" | "Amount";
  shouldShowDropDown?: boolean;
  InitialStatus?:
    | "Funded"
    | "Not Funded"
    | "Approved"
    | "Overbudget"
    | "Not Approved"
    | "Completed"
    | "Not Completed"
    | "All";
}

const ProposalCountAmountSum = (props: VariationOfFundsProps) => {
  const {
    xlabel,
    ylabel,
    type = "Proposal",
    // single_fund,
    // type = "List",
    InitialStatus = "Funded",
    shouldShowDropDown = true,
  } = props;

  const [status, setStatus] = useState<
    | "Funded"
    | "Not Funded"
    | "Approved"
    | "Overbudget"
    | "Not Approved"
    | "Completed"
    | "Not Completed"
    | "All"
  >(InitialStatus);

  const handleChangeStatus = (event: any) => {
    setStatus(event.target.value);
  };

  const { data, loading } = usePropertyData({
    property_name: "Amount",
    aggregation_type: type === "Proposal" ? "Count" : "Sum",
    status_grouping: "None",
    proposal_status: status as "Funded",
    fund_id: undefined,
  });

  let chartData: any[] = [];
  let categories: any[] = [];

  if (loading) {
    chartData = [];
  } else {
    data.forEach((item: any) => {
      chartData.push(item.value);
      categories.push(item.fund_name);
    });
  }

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const content = (showMaxButton: boolean) => {
    return (
      <>
        <Paper elevation={3} className={styles.chartContainer}>
          <div className="horizontalCenter">
            <Typography className={styles.chartHeader}>
              {type === "Proposal"
                ? `${status} Proposals in Different Funds`
                : `Total ${status} Amount in Different Funds`}
            </Typography>
          </div>
          {shouldShowDropDown && (
            <div className="horizontalCenter">
              <div className={styles.selectOptionRow}>
                {
                  <FormControl size="small">
                    <InputLabel>Proposal Status</InputLabel>
                    <Select
                      value={status}
                      label="Proposal Status"
                      onChange={handleChangeStatus}
                      defaultValue="Funded"
                      size="small"
                    >
                      {[
                        "Funded",
                        "Not Funded",
                        "Approved",
                        "Overbudget",
                        "Not Approved",
                        "Completed",
                        "Not Completed",
                        "All",
                      ].map((fund: any) => (
                        <MenuItem
                          style={{ fontSize: "14px" }}
                          value={fund}
                          key={`fund-variation-${status}`}
                        >
                          {fund}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                }
              </div>
            </div>
          )}

          <div style={{ width: "100%" }}>
            <BarChart
              loading={loading}
              chartData={chartData}
              // legend={
              //   status_grouping === "Ternary"
              //     ? ["Funded", "Overbudget", "Not Approved"]
              //     : ["Funded", "Not Funded"]
              // }
              xLabel={xlabel}
              yLabel={ylabel}
              categories={categories}
            />
          </div>

          {getChartBottomIcons(showMaxButton, setOpen)}
          {getChartInfoIcons(desc["proposal"]["count"])}
        </Paper>
      </>
    );
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.fullScreenChart}>{content(false)}</Box>
      </Modal>
      {content(true)}
    </>
  );
};

export default ProposalCountAmountSum;
